// src/IconChevronDownLine.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.21",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.2612 7.27589C20.8613 6.89499 20.2283 6.9104 19.8474 7.31032L11.9996 15.55L4.15284 7.31037C3.77196 6.91043 3.13899 6.89497 2.73904 7.27584C2.3391 7.65671 2.32364 8.28969 2.70451 8.68963L11.2754 17.6896C11.4641 17.8878 11.7258 18 11.9995 18C12.2732 18 12.5349 17.8879 12.7236 17.6897L21.2956 8.68968C21.6765 8.28976 21.6611 7.65679 21.2612 7.27589Z",
        fill: "currentColor"
      }
    ) })
  }
);
var IconChevronDownLine = forwardRef(Icon);
var IconChevronDownLine_default = IconChevronDownLine;
export {
  IconChevronDownLine_default as default
};
